<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12" sm="12">
        <iq-card>
          <template v-slot:headerTitle>
            <h4 class="card-title">{{ ($route.query.hospital_id === 0) ? $t('hospital_configuration.assign_dept_entry') : $t('hospital_configuration.assign_dept_modify') }}</h4>
          </template>
          <template v-slot:body>
            <b-row>
              <b-col lg="12" sm="12">
                <ValidationObserver ref="form"  v-slot="{ handleSubmit, reset }">
                  <b-form  @submit.prevent="handleSubmit(createData)" @reset.prevent="reset" >
                    <b-overlay :show="unitLoad">
                    <b-row>
                      <b-col lg="3" sm="3">
    <ValidationProvider name="Area Type" vid="hos_area_type_id">
        <b-form-group
        class="row"
        label-cols-sm="12"
        label-for="hos_area_type_id "
        slot-scope="{ valid, errors }"
        >
        <template v-slot:label>
          {{$t('org_pro.area_type')}}
        </template>
        <b-form-select
          plain
          v-model="assignDeptData.hos_area_type_id"
          id="hos_area_type_id"
          :options="getHosAreaTypeList"
          @change="getAreaTypeData(assignDeptData.area_type_id)"
          :state="errors[0] ? false : (valid ? true : null)"
        >
        <template v-slot:first>
        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
        </template>
        </b-form-select>
        <div class="invalid-feedback">
          {{ errors[0] }}
        </div>
        </b-form-group>
    </ValidationProvider>
  </b-col>
  <b-col lg="3" sm="3">
    <ValidationProvider name="Division" vid="division_id">
        <b-form-group
        class="row"
        label-cols-sm="12"
        label-for="division_id "
        slot-scope="{ valid, errors }"
        >
        <template v-slot:label>
          {{$t('externalUser.division')}}
        </template>
        <b-form-select
          plain
          v-model="assignDeptData.hos_division_id"
          id="division_id"
          :options="getHosDivisionList"
          :state="errors[0] ? false : (valid ? true : null)"
        >
        <template v-slot:first>
        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
        </template>
        </b-form-select>
        <div class="invalid-feedback">
          {{ errors[0] }}
        </div>
        </b-form-group>
    </ValidationProvider>
  </b-col>
  <b-col lg="3" sm="3">
    <ValidationProvider name="District" vid="district_id">
        <b-form-group
        class="row"
        label-cols-sm="12"
        label-for="district_id "
        slot-scope="{ valid, errors }"
        >
        <template v-slot:label>
          {{$t('org_pro_district.district')}}
        </template>
        <b-form-select
          plain
          v-model="assignDeptData.hos_district_id"
          id="district_id"
          :options="getHosDistrictList"
          :state="errors[0] ? false : (valid ? true : null)"
        >
        <template v-slot:first>
        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
        </template>
        </b-form-select>
        <div class="invalid-feedback">
          {{ errors[0] }}
        </div>
        </b-form-group>
    </ValidationProvider>
  </b-col>
  <b-col lg="3" sm="3" v-if="assignDeptData.hos_area_type_id > 1">
    <ValidationProvider name="Upazila" vid="upazila_id">
        <b-form-group
        class="row"
        label-cols-sm="12"
        label-for="upazila_id "
        slot-scope="{ valid, errors }"
        >
        <template v-slot:label>
          {{$t('org_pro_upazilla.upazilla')}}
        </template>
        <b-form-select
          plain
          v-model="assignDeptData.hos_upazila_id"
          id="upazila_id"
          :options="getHosUpazillaList"
          :state="errors[0] ? false : (valid ? true : null)"
        >
        <template v-slot:first>
        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
        </template>
        </b-form-select>
        <div class="invalid-feedback">
          {{ errors[0] }}
        </div>
        </b-form-group>
    </ValidationProvider>
  </b-col>
  <b-col lg="3" sm="3" v-if="assignDeptData.hos_area_type_id === 1">
    <ValidationProvider name="City Corporation" vid="city_corporation_id">
        <b-form-group
        class="row"
        label-cols-sm="12"
        label-for="city_corporation_id "
        slot-scope="{ valid, errors }"
        >
        <template v-slot:label>
          {{$t('org_pro.city_corporation')}}
        </template>
        <b-form-select
          plain
          v-model="assignDeptData.hos_city_corporation_id"
          id="city_corporation_id"
          :options="getHosCityCorporationList"
          :state="errors[0] ? false : (valid ? true : null)"
        >
        <template v-slot:first>
        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
        </template>
        </b-form-select>
        <div class="invalid-feedback">
          {{ errors[0] }}
        </div>
        </b-form-group>
    </ValidationProvider>
  </b-col>
                        <b-col lg="12" sm="12">
                            <ValidationProvider name="Hopital" vid="hospital_id" rules="required|min_value:1">
                                <b-form-group
                                    class="row"
                                    label-cols-sm="12"
                                    label-for="hospital_id"
                                    slot-scope="{ valid, errors }"
                                    >
                                    <template v-slot:label>
                                    {{$t('hospital_configuration.hospital_name')}} <span class="text-danger">*</span>
                                    </template>
                                    <b-form-select
                                    :disabled="$route.query.hospital_id ? true : false"
                                    plain
                                    v-model="assignDeptData.hospital_id"
                                    :options="hospitalList"
                                    id="hospital_id"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    >
                                    <template v-slot:first>
                                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                    </template>
                                    </b-form-select>
                                    <span  v-if="$route.query.hospital_id"></span><span v-else class="text-danger" style="font-size:12px">{{$t('hospital_configuration.has_department')}}</span>
                                    <div class="invalid-feedback">
                                    {{ errors[0] }}
                                    </div>
                                </b-form-group>
                                </ValidationProvider>
                        </b-col>
                        <b-col lg="6" sm="6">
                            <ValidationProvider name="Category" vid="hospital_category">
                                <b-form-group
                                    class="row"
                                    label-cols-sm="4"
                                    label-for="hospital_category "
                                    slot-scope="{ valid, errors }"
                                    >
                                    <template v-slot:label>
                                        {{$t('hospital_configuration.hospital_category')}}
                                    </template>
                                    <b-form-select
                                    :disabled="$route.query.hospital_id ? true : true"
                                    plain
                                    v-model="assignDeptData.category"
                                    id="category"
                                    :options="getHospitalCategoryList"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    >
                                    <template v-slot:first>
                                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                    </template>
                                    </b-form-select>
                                    <div class="invalid-feedback">
                                    {{ errors[0] }}
                                    </div>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col lg="6" sm="6">
                            <ValidationProvider name="Area Type" vid="area_type_id">
                                <b-form-group
                                    class="row"
                                    label-cols-sm="4"
                                    label-for="area_type_id "
                                    slot-scope="{ valid, errors }"
                                    >
                                    <template v-slot:label>
                                        {{$t('org_pro.area_type')}}
                                    </template>
                                    <b-form-select
                                    :disabled="$route.query.hospital_id ? true : true"
                                    plain
                                    v-model="assignDeptData.area_type_id"
                                    id="area_type_id"
                                    :options="getAreaTypeList"
                                    @change="getAreaTypeData(assignDeptData.area_type_id)"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    >
                                    <template v-slot:first>
                                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                    </template>
                                    </b-form-select>
                                    <div class="invalid-feedback">
                                    {{ errors[0] }}
                                    </div>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col lg="6" sm="6" v-show="ItemShow">
                            <ValidationProvider name="Division" vid="division_id">
                                <b-form-group
                                    class="row"
                                    label-cols-sm="4"
                                    label-for="division_id"
                                    slot-scope="{ valid, errors }"
                                    >
                                    <template v-slot:label>
                                    {{ $t('org_pro_division.division')}}
                                    </template>
                                    <b-form-select
                                    :disabled="$route.query.hospital_id ? true : true"
                                    plain
                                    v-model="assignDeptData.division_id"
                                    :options="divisionList"
                                    id="division_id"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    >
                                    <template v-slot:first>
                                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                    </template>
                                    </b-form-select>
                                    <div class="invalid-feedback">
                                    {{ errors[0] }}
                                    </div>
                                </b-form-group>
                            </ValidationProvider>
                      </b-col>
                      <b-col lg="6" sm="6" v-show="ItemShow">
                        <ValidationProvider name="District" vid="district_id">
                            <b-form-group
                                class="row"
                                label-cols-sm="4"
                                label-for="district_id"
                                slot-scope="{ valid, errors }"
                                >
                                <template v-slot:label>
                                {{ $t('org_pro_district.district')}}
                                </template>
                                <b-form-select
                                :disabled="$route.query.hospital_id ? true : true"
                                plain
                                v-model="assignDeptData.district_id"
                                :options="districtList"
                                id="district_id"
                                :state="errors[0] ? false : (valid ? true : null)"
                                >
                                <template v-slot:first>
                                    <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                </template>
                                </b-form-select>
                                <div class="invalid-feedback">
                                {{ errors[0] }}
                                </div>
                            </b-form-group>
                        </ValidationProvider>
                      </b-col>
                      <b-col lg="6" sm="6" v-if="assignDeptData.area_type_id > 1">
                        <ValidationProvider name="Upazila" vid="upazila_id">
                            <b-form-group
                                class="row"
                                label-cols-sm="4"
                                label-for="upazila_id"
                                slot-scope="{ valid, errors }"
                                >
                                <template v-slot:label>
                                {{ $t('org_pro_upazilla.upazilla')}}
                                </template>
                                <b-form-select
                                :disabled="$route.query.hospital_id ? true : true"
                                plain
                                v-model="assignDeptData.upazilla_id"
                                :options="upazilaList"
                                id="upazila_id"
                                :state="errors[0] ? false : (valid ? true : null)"
                                >
                                <template v-slot:first>
                                    <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                </template>
                                </b-form-select>
                                <div class="invalid-feedback">
                                {{ errors[0] }}
                                </div>
                            </b-form-group>
                        </ValidationProvider>
                      </b-col>
                      <b-col lg="6" sm="6" v-if="assignDeptData.area_type_id === 1">
                        <ValidationProvider name="City Corporation" vid="city_corporation_id">
                            <b-form-group
                                class="row"
                                label-cols-sm="4"
                                label-for="city_corporation_id"
                                slot-scope="{ valid, errors }"
                                >
                                <template v-slot:label>
                                    {{ $t('org_pro.city_corporation') }}
                                </template>
                                <b-form-select
                                :disabled="$route.query.hospital_id ? true : true"
                                plain
                                v-model="assignDeptData.city_corporation_id"
                                :options="cityCorporationList"
                                id="city_corporation_id"
                                :state="errors[0] ? false : (valid ? true : null)"
                                >
                                <template v-slot:first>
                                    <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                </template>
                                </b-form-select>
                                <div class="invalid-feedback">
                                {{ errors[0] }}
                                </div>
                            </b-form-group>
                        </ValidationProvider>
                      </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="6">
                            <b-table-simple bordered>
                                <thead>
                                    <tr>
                                        <th scope="col" width="15%" class="text-center">{{ $t('globalTrans.sl_no') }}</th>
                                        <th scope="col" class="text-center" width="60%">{{ $t('hospital_configuration.assign_dept') }}</th>
                                        <th scope="col" width="25%" class="text-center">{{ $t('globalTrans.action') }}</th>
                                    </tr>
                                </thead>
                                <b-tbody>
                                    <b-tr v-for="(item, index) in assignDeptData.deptData" :key="index">
                                        <b-td class="text-center">{{ $n(index + 1) }}</b-td>
                                        <b-td class="text-center">
                                            <ValidationProvider name="Department" vid="department_id" rules="required|min_value:1">
                                                <b-form-group style="margin-left: -30px;"
                                                    class="row"
                                                    label-cols-sm="1"
                                                    label-for="department_id"
                                                    slot-scope="{ valid, errors }"
                                                    >
                                                    <b-form-select
                                                    plain
                                                    v-model="item.department_id"
                                                    id="department_id"
                                                    :options="departmentList"
                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                    >
                                                    <template v-slot:first>
                                                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                    </template>
                                                    </b-form-select>
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-td>
                                        <b-td class="text-center">
                                            <button type="button" class="btn btn-sm btn-primary" @click.prevent="addItem()" v-show="index == assignDeptData.deptData.length-1"><i class="ri-add-circle-line"></i></button>&nbsp;&nbsp;
                                            <button type="button" class="btn btn- iq-bg-danger btn-sm" @click="deleteItem(index)" v-show="assignDeptData.deptData.length > 1"><i class="ri-delete-bin-line m-0"></i></button>
                                        </b-td>
                                    </b-tr>
                                </b-tbody>
                            </b-table-simple>
                        </b-col>
                    </b-row>
                    <div class="row">
                      <div class="col-sm-3"></div>
                      <div class="col text-right">
                        <b-button type="submit" variant="primary" class="mr-2">{{$route.query.hospital_id ? $t('globalTrans.update') : $t('globalTrans.save')}}</b-button>
                        &nbsp;
                        <router-link to="/hospital-disability-service/configuration/assign-department" :class="'btn btn-danger text-light'">{{  $t('globalTrans.cancel') }}</router-link>
                      </div>
                    </div>
                    </b-overlay>
                  </b-form>
                </ValidationObserver>
              </b-col>
            </b-row>
          </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { core } from '@/config/pluginInit'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import RestApi, { hospitalServiceBaseUrl } from '@/config/api_config'
import { assignDeptStoreApi, assignDeptUpdateApi, assignDeptShowApi, assignUserHospitalApi } from '../../api/routes'
import Custom from '../../../../../store/custom'

export default {
  props: ['id'],
  components: {
    ValidationObserver,
    ValidationProvider
  },
  created () {
    var officeId = this.$store.state.Auth.authUser.office_id
    if (officeId > 1) {
        this.userId = this.$store.state.Auth.authUser.user_id
        if (this.userId > 1) {
            this.getUserWiseHospital(this.userId)
        }
    } else {
        this.$store.state.HospitalDisabilityService.commonObj.hospitalInfoList.filter(item => item.status === 1 && item.is_jointly_formated === 0).map((obj, key) => {
            this.hospitalIds.push(obj.value)
        })
        this.hospitalList = this.getHospitalList()
    }
    if (this.$route.query.hospital_id) {
      this.getAssignUserData(this.$route.query.hospital_id)
    }
  },
  mounted () {
    core.index()
  },
  data () {
    return {
        ItemShow: false,
        saveBtnName: this.id ? this.$t('globalTrans.update') : this.$t('globalTrans.save'),
        assignDeptData: {
            id: '',
            status: '',
            department_id: 0,
            category: '',
                hos_area_type_id: 0,
                hos_division_id: 0,
                hos_district_id: 0,
                hos_upazila_id: 0,
                hos_city_corporation_id: 0,
                hospital_id: '',
            area_type_id: 0,
            division_id: 0,
            district_id: 0,
            upazilla_id: 0,
            city_corporation_id: 0,
            pauroshoba_id: 0,
            deptData: [
                {
                    department_id: ''
                }
            ],
            department_ids: []
        },
        deptAr: [],
        hospitalList: [],
        hospitalIds: [],
        designationList: [],
        userList: [],
        unitLoad: false
    }
  },
  computed: {
      getHosDivisionList: function () {
        return this.$store.state.commonObj.divisionList.filter(item => item.status === 0)
    },
    getHosDistrictList: function () {
        return this.$store.state.commonObj.districtList.filter(item => item.status === 0 && item.division_id === parseInt(this.assignDeptData.hos_division_id))
    },
    getHosCityCorporationList: function () {
        return this.$store.state.commonObj.cityCorporationList.filter(item => item.status === 0 && item.district_id === parseInt(this.assignDeptData.hos_district_id))
    },
    getHosUpazillaList: function () {
        return this.$store.state.commonObj.upazilaList.filter(item => item.status === 0 && item.district_id === parseInt(this.assignDeptData.hos_district_id))
    },
    getHosAreaTypeList: function () {
        const objectData = this.$store.state.commonObj.wardTypeList
        return objectData.map((obj, key) => {
            if (this.$i18n.locale === 'bn') {
                return { value: obj.id, text: obj.name_bn }
            } else {
                return { value: obj.id, text: obj.name }
            }
        })
    },
    orgList: function () {
      return this.$store.state.orgList.filter(item => item.status === 0)
    },
    getHospitalCategoryList: function () {
        const objectData = this.$store.state.HospitalDisabilityService.commonObj.hospitalCategoryList
        return objectData.map((obj, key) => {
            if (this.$i18n.locale === 'bn') {
                return { value: obj.id, text: obj.name_bn }
            } else {
                return { value: obj.id, text: obj.name }
            }
        })
    },
    departmentList: function () {
        return this.$store.state.HospitalDisabilityService.commonObj.deptList.filter(item => item.status === 1)
    },
    divisionList: function () {
        return this.$store.state.commonObj.divisionList.filter(item => item.status === 0)
    },
    districtList: function () {
        return this.$store.state.commonObj.districtList.filter(item => item.status === 0 && item.division_id === parseInt(this.assignDeptData.division_id))
    },
    upazilaList: function () {
        return this.$store.state.commonObj.upazilaList.filter(item => item.status === 0 && item.district_id === parseInt(this.assignDeptData.district_id))
    },
    cityCorporationList: function () {
        return this.$store.state.commonObj.cityCorporationList.filter(item => item.status === 0 && item.district_id === parseInt(this.assignDeptData.district_id))
    },
    getAreaTypeList: function () {
        const objectData = Custom.wardTypeList
        return objectData.map((obj, key) => {
            if (this.$i18n.locale === 'bn') {
                return { value: obj.id, text: obj.name_bn }
            } else {
                return { value: obj.id, text: obj.name }
            }
        })
    }
  },
  watch: {
      'assignDeptData.hos_area_type_id': function () {
        this.hospitalList = this.getHospitalList()
    },
    'assignDeptData.hos_division_id': function () {
        this.hospitalList = this.getHospitalList()
    },
    'assignDeptData.hos_district_id': function () {
        this.hospitalList = this.getHospitalList()
    },
    'assignDeptData.hos_upazila_id': function () {
        this.hospitalList = this.getHospitalList()
    },
    'assignDeptData.hos_city_corporation_id': function () {
        this.hospitalList = this.getHospitalList()
    },
    'assignDeptData.hospital_id': function (newVal, oldVal) {
      if (newVal && oldVal !== 0) {
          this.assignDeptData.department_id = 0
          this.assignDeptData.hos_ward_id = 0
          const hospital = this.$store.state.HospitalDisabilityService.commonObj.hospitalInfoList.find(item => item.value === parseInt(newVal))
          this.assignDeptData.hos_area_type_id = hospital.area_type_id ? hospital.area_type_id : 0
          this.assignDeptData.hos_division_id = hospital.division_id ? hospital.division_id : 0
          this.assignDeptData.hos_district_id = hospital.district_id ? hospital.district_id : 0
          this.assignDeptData.hos_upazila_id = hospital.upazilla_id ? hospital.upazilla_id : 0
          this.assignDeptData.hos_city_corporation_id = hospital.city_corporation_id ? hospital.city_corporation_id : 0
        }
        if (newVal < 1) {
          this.assignDeptData.hos_area_type_id = 0
          this.assignDeptData.hos_division_id = 0
          this.assignDeptData.hos_district_id = 0
          this.assignDeptData.hos_upazila_id = 0
          this.assignDeptData.hos_city_corporation_id = 0
        }
        this.getHospitaldata()
    }
  },
  methods: {
    async getUserWiseHospital (userId) {
        const params = Object.assign({ user_id: userId })
        const result = await RestApi.getData(hospitalServiceBaseUrl, assignUserHospitalApi, params)
        if (result.success) {
                this.hospitalIds = result.data
                this.hospitalList = this.getHospitalList()
        } else {
              this.$store.state.HospitalDisabilityService.commonObj.hospitalInfoList.filter(item => item.status === 1 && item.is_jointly_formated === 0).map((obj, key) => {
                  this.hospitalIds.push(obj.value)
              })
                    this.hospitalList = this.getHospitalList()
        }
    },
    deleteItem (index) {
        this.assignDeptData.deptData.splice(index, 1)
        this.assignDeptData.department_ids.splice(index, 1)
    },
    addItem () {
        const validate = this.assignDeptData.deptData.some(data => data.department_id === this.assignDeptData.department_id)
        if (!validate) {
            this.assignDeptData.deptData.push({
                department_id: this.assignDeptData.department_id
            })
        } else {
        }
    },
    deptNameById (id) {
        const dept = this.$store.state.HospitalDisabilityService.commonObj.deptList.find(dept => dept.value === id)
        if (this.$i18n.locale === 'bn') {
            return dept.text_bn
        } else {
            return dept.text_en
        }
    },
    async getAssignUserData (hosId) {
        this.unitLoad = true
        const result = await RestApi.getData(hospitalServiceBaseUrl, assignDeptShowApi + '/' + hosId)
        if (result.success) {
            this.assignDeptData.hospital_id = result.data.hospital_id
            this.assignDeptData.deptData = result.data.deptArr
            const deptArrData = result.data.deptArr.map(deptt => (deptt.department_id))
            this.assignDeptData.department_ids = deptArrData
            this.unitLoad = false
        } else {
            this.assignDeptData = {}
            this.unitLoad = false
        }
    },
    getHospitaldata () {
                const hospitalList = this.$store.state.HospitalDisabilityService.commonObj.hospitalInfoList.filter(item => item.status === 1 && item.value === parseInt(this.assignDeptData.hospital_id))
                this.getAreaTypeData(this.assignDeptData.area_type_id)
                this.assignDeptData.category = hospitalList[0].category
                this.assignDeptData.area_type_id = hospitalList[0].area_type_id
                this.assignDeptData.division_id = hospitalList[0].division_id
                this.assignDeptData.district_id = hospitalList[0].district_id
                this.assignDeptData.upazilla_id = hospitalList[0].upazilla_id
                this.assignDeptData.city_corporation_id = hospitalList[0].city_corporation_id
                this.assignDeptData.pauroshoba_id = hospitalList[0].pauroshoba_id
                this.assignDeptData.hospital_id = hospitalList[0].value
    },
    getHospitalList () {
        let hospitalList = this.$store.state.HospitalDisabilityService.commonObj.hospitalInfoList.filter(item => item.status === 1 && item.is_jointly_formated === 0)
        if (this.assignDeptData.hos_area_type_id > 0) {
          hospitalList = hospitalList.filter(hospital => hospital.area_type_id === this.assignDeptData.hos_area_type_id)
        }

        if (this.assignDeptData.hos_division_id > 0) {
          hospitalList = hospitalList.filter(hospital => hospital.division_id === this.assignDeptData.hos_division_id)
        }

        if (this.assignDeptData.hos_district_id > 0) {
          hospitalList = hospitalList.filter(hospital => hospital.district_id === this.assignDeptData.hos_district_id)
        }

        if (this.assignDeptData.hos_city_corporation_id > 0) {
          hospitalList = hospitalList.filter(hospital => hospital.city_corporation_id === this.assignDeptData.hos_city_corporation_id)
        }
        if (this.assignDeptData.hos_upazila_id > 0) {
          hospitalList = hospitalList.filter(hospital => hospital.upazilla_id === this.assignDeptData.hos_upazila_id)
        }
        hospitalList = hospitalList.map(obj => {
            if (obj.has_department === 1) {
                return { value: obj.value, text: this.$i18n.locale === 'en' ? obj.text_en : obj.text_bn, disabled: true }
            } else {
                return { value: obj.value, text: this.$i18n.locale === 'en' ? obj.text_en : obj.text_bn }
            }
        })
        var hosId = this.$route.query.hospital_id
        if (hosId > 1) {
                hospitalList = this.$store.state.HospitalDisabilityService.commonObj.hospitalInfoList.filter(item => item.status === 1 && item.value === parseInt(hosId))
                this.getAreaTypeData(this.assignDeptData.area_type_id)
                this.assignDeptData.category = hospitalList[0].category
                this.assignDeptData.area_type_id = hospitalList[0].area_type_id
                this.assignDeptData.division_id = hospitalList[0].division_id
                this.assignDeptData.district_id = hospitalList[0].district_id
                this.assignDeptData.upazilla_id = hospitalList[0].upazilla_id
                this.assignDeptData.city_corporation_id = hospitalList[0].city_corporation_id
                this.assignDeptData.pauroshoba_id = hospitalList[0].pauroshoba_id
                this.assignDeptData.hospital_id = hospitalList[0].value
                if (hospitalList === []) {
                    hospitalList = this.$store.state.HospitalDisabilityService.commonObj.hospitalInfoList.filter(item => item.status === 1 && item.is_jointly_formated === 0)
                }
        } else {
            var officeId = this.$store.state.Auth.authUser.office_id
            if (officeId > 1) {
                this.userId = this.$store.state.Auth.authUser.user_id
                if (this.userId > 1) {
                    if (this.hospitalIds.length > 0) {
                        hospitalList = hospitalList.filter((p) => this.hospitalIds.includes(p.value))
                    }
                }
            } else {
                  if (hospitalList === []) {
                      hospitalList = this.$store.state.HospitalDisabilityService.commonObj.hospitalInfoList.filter(item => item.status === 1 && item.is_jointly_formated === 1)
                  } else {
                      return hospitalList
                  }
            }
        }
        return hospitalList
    },
    getDesignationList (orgId = null) {
      const designationList = this.$store.state.commonObj.designationList
      let listObject = []
      if (orgId) {
        listObject = designationList.filter(designation => designation.org_id === orgId)
      } else {
        listObject = designationList
      }
      const tmpList = listObject.map((obj, index) => {
        if (this.$i18n.locale === 'bn') {
          return { value: obj.value, text: obj.text_bn }
        } else {
          return { value: obj.value, text: obj.text_en }
        }
      })
      return tmpList
    },
    async createData () {
        this.$store.dispatch('mutateCommonProperties', { loading: true })
        let result = null
        const loadinState = { loading: false, listReload: true }
        const config = {
            headers: { 'content-type': 'multipart/form-data' }
        }

        if (this.$route.query.hospital_id) {
            result = await RestApi.putData(hospitalServiceBaseUrl, `${assignDeptUpdateApi}/${this.$route.query.hospital_id}`, this.assignDeptData, config)
        } else {
            result = await RestApi.postData(hospitalServiceBaseUrl, assignDeptStoreApi, this.assignDeptData, config)
        }

        this.$store.dispatch('mutateCommonProperties', loadinState)

        if (result.success) {
            this.$store.dispatch('mutateCommonProperties', { hasDropdownLoaded: false })
            this.$store.dispatch('HospitalDisabilityService/mutateCommonObj', { hasDropdownLoaded: false })
            this.$toast.success({
            title: this.$t('globalTrans.success'),
            message: this.id ? this.$t('globalTrans.update_msg') : this.$t('globalTrans.save_msg'),
            color: '#D6E09B'
            })

            this.$bvModal.hide('modal-4')
            this.$router.push('/hospital-disability-service/configuration/assign-department')
        } else {
            this.$refs.form.setErrors(result.errors)
        }
    },
    getAreaTypeData (typeId) {
      this.ItemShow = true
      if (typeId === 1) {
          this.CityCorpItemShow = true
          this.PauroshobaItemShow = false
          this.UnionItemShow = false
      } else if (typeId === 2) {
          this.CityCorpItemShow = false
          this.PauroshobaItemShow = true
          this.UnionItemShow = false
      } else if (typeId === 3) {
          this.CityCorpItemShow = false
          this.PauroshobaItemShow = false
          this.UnionItemShow = true
      }
    }
  }
}
</script>
<style>
select option:disabled {
    color: green !important;
    font-weight: bold;
}
</style>
